import React, { useState, useImperativeHandle } from 'react';
import './../../styles/Inputs.css';

function TextField({ label, defaultValue, gridWidth, icon , onChange , visible } , ref ) {
    const startValue = defaultValue ?? '';
    const [ value, setValue ] = useState( startValue );
    
    useImperativeHandle(ref, () => ({
        getValue: () => value,
        setValue: ( newVal ) => setValue(newVal),
    }));

    const handleChange = ( e ) => {
        setValue( e.target.value );
        if ( typeof onChange === 'function' ) {
            onChange( e.target.value );
        }
    };

    const containerClass = [
        'textfield',
        gridWidth === 'HALF' ? 'half' : 'full',
        visible === false ? 'hidden' : ''
    ].join(' ').trim();
    
    return (
        <div className={containerClass}>
            {label != null && (
                <label className="textfield-label">
                    {icon != null && 
                        <span className="textfield-icon">
                            <div dangerouslySetInnerHTML={ { __html: icon } }></div>
                        </span>}
                    {label}
                </label>
            )}
    
            <input
                type="text"
                className="textfield-input"
                value={value}
                onChange={ handleChange }
            />
        </div>
    );
}

export default React.forwardRef(TextField);